import Api from './ApiBase'
import {CreateChannel, CreateOrUpdateChannelResponse, GetChannelsResponse} from "@/repository/messagehub.dtos";
import {AxiosError, AxiosResponse} from "axios";
export class ChannelApi extends Api{

    async getChannels(): Promise<GetChannelsResponse>{
        let result: AxiosResponse =  await this.Client.get('/channel')
        return <GetChannelsResponse> result.data
    }
    async createChannel(channel: CreateChannel): Promise<AxiosResponse>{
        const json = JSON.stringify(channel);
        let result: AxiosResponse = await this.Client.post('/channel', json)
        return result
    }
    async deleteChannel(id: string){
        let result: AxiosResponse = await this.Client.delete('/channel?id='+id)
        return result
    }
}
export default ChannelApi;
